import { View } from 'react-native';
import type { DividerProps } from './types';
import { Flex } from '@banhala/ui-kit';
import { useLogDisplayDivider } from './useLogDisplayDivider';

export const Divider = ({ entity, isVisible }: DividerProps) => {
  useLogDisplayDivider(entity, isVisible);

  return (
    <Flex.Column>
      {entity?.map((divider, i) => {
        return (
          <View
            key={i}
            style={{
              height: divider.item.height,
              backgroundColor: divider.item.color,
            }}
          />
        );
      })}
    </Flex.Column>
  );
};
